import { render, staticRenderFns } from "./SelectionScreen.vue?vue&type=template&id=53e49f66&scoped=true&"
import script from "./SelectionScreen.vue?vue&type=script&lang=ts&"
export * from "./SelectionScreen.vue?vue&type=script&lang=ts&"
import style0 from "./SelectionScreen.vue?vue&type=style&index=0&id=53e49f66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e49f66",
  null
  
)

export default component.exports